import React, { Component } from 'react';
import { FormLabeledItem, Input, ItemChooser, CheckBox, TextArea, SelectList, Button, FormDataObj } from '../../../components/FormUI';
import User from '../../../api/User';

import { Grid, Segment } from 'semantic-ui-react'

import './UserForm.css';

import DatePicker from 'react-datepicker';

import moment from 'moment';
import { CountrySelectList, ProvinceSelectList } from '../../../components/DataSelectList';
import PatientService from '../../../api/services/PatientService';
import PhysicianService from '../../../api/services/PhysicianService';
import { NotificationManager } from 'react-notifications';
import DoctorTypeList from '../../../components/selectlists/DoctorTypeList';
import ClientNotesView from '../ClientNotesView';

export default class DrUserForm extends Component{
    form = {};
    state = {errors: {}};
    /*componentWillReceiveProps(props){
        this.form = new User(props.user || {});
    }*/

    constructor(props) {
        super(props);
        this.form = new FormDataObj(new User(this.props.user || {}));
        this.handleBODChange = this.handleBODChange.bind(this);
    }
    
    submit(){
        let errors = this.form.getErrorState();
        console.log('Form Data Errors:', errors)
        if(errors != null){
            
            this.setState({errors:errors});
            return;
        }

        let isNewPatient = !this.form.data.clientId;
        let msg = isNewPatient? 'Physician Created!':'Physician Updated!';
        
        PhysicianService.Save(this.form.data).then((user) => {
            this.form.data = new User(user);
            /*for(let p in user){
                this.props.user[p] = user[p];
            }*/
            this.setState({saving:false});
            NotificationManager.success(msg);
        })
        this.setState({saving:true, errors:{}});
    }    

    handleBODChange(d){
        console.log("DOB:", d)
        this.form.data.birthDate = moment(d).format('YYYY-M-D');
        this.forceUpdate();
    }
    handleCheckBox = ({value})=>{
        //console.log('Handle Check Box:', value);
        this.form.setValue('emailPref', value);
        this.forceUpdate();
    }

    /*customInput={<Input name='birthDate' value={this.form.birthDate} form={this.form} placeholder='Date of Birth' tabIndex={1} />}*/
    render(){       
        console.log("UserForm:", this.form);
        let user = this.form.data;
        let label = (user.clientId) ? 'Edit Doctor' : 'Add New Doctor';
        let saveLabel = (user.clientId) ? 'Update' : 'Save';
        let errors = this.state.errors;
        //this.form = new User(this.props.user || {});
        return(
            <div className='user-form'>
                <FormLabeledItem label={label} parentItem>
                    <div className='form-table1 table hmax align-bottom'>
                        <div>
                            <div><Input placeholder='First Name' name='firstName' form={this.form} tabIndex={1} error={errors['firstName']} required /></div> 
                            <div><Input placeholder='Last Name' name='lastName' form={this.form} tabIndex={1} error={errors['lastName']} required /></div>
                            <div><Input name='homePhone' form={this.form} placeholder='Fax' tabIndex={2}/></div>
                        </div>
                        <div>
                            <div>
                                <FormLabeledItem label='Gender'>
                                    <ItemChooser className='hmax' name='gender' form={this.form} >
                                        <div itemId='Male' tabIndex={1}>Male</div>
                                        <div itemId='Female' tabIndex={1}>Female</div>
                                        <div itemId='Other' tabIndex={1}>Other</div>
                                    </ItemChooser>
                                    
                                </FormLabeledItem>
                            </div>
                            <div>
                                <DoctorTypeList 
                                    isCreatable={true}
                                    form={this.form} 
                                    name='typeOfWork'
                                    value='General Practitioner'                                   
                                    tabIndex={1}
                                />
                            </div>
                            <div><Input type='phone' name='cellPhone' form={this.form} placeholder='Cell Phone' tabIndex={2}/></div>
                        </div>
                        <div>
                            <div><Input name='address2' form={this.form} placeholder='Unit / Apt #' tabIndex={1} /></div>
                            <div><Input name='address1' form={this.form} placeholder='Address' tabIndex={1} /></div>
                            <div><Input name='workPhone' form={this.form} placeholder='Work Phone' tabIndex={2}/></div>
                        </div>
                        <div>
                            <div><Input name='city' form={this.form} placeholder='City / Town' tabIndex={1} /></div>
                            <div><Input name='postalCode' form={this.form} placeholder='Postal Code' tabIndex={1} /></div>
                            <div><Input type='email' name='email' form={this.form} placeholder='Email' tabIndex={2}/></div>
                        </div>
                        <div>
                            <div><ProvinceSelectList name='province' form={this.form} placeholder='Province' tabIndex={1} simpleValue={true} /></div>
                            <div><CountrySelectList name='country' form={this.form} placeholder='Country' value='CA' simpleValue={true} tabIndex={1} /></div>
                            <div>
                                <FormLabeledItem label='Email Preferences'>
                                    <CheckBox radio label="Email marketing consent recieved" name='emailPref' value='emcr' form={this.form} tabIndex={2} onChange={this.handleCheckBox} /><br/>
                                    <CheckBox radio label="No, do not ask again." name='emailPref' value='noask' form={this.form} tabIndex={2} onChange={this.handleCheckBox} />
                                </FormLabeledItem>
                            </div>
                        </div>
                    </div>
                    <div className='dr-form-save-btn'>
                        <Button caption={saveLabel} className='green' onClick={()=> this.submit()} isBusy={this.state.saving} tabIndex={4} />
                    </div>
                    <div className='divider'></div>
                   
                </FormLabeledItem>
                <FormLabeledItem label="Notes">
                    <ClientNotesView clientId={user.clientId} />
                    {/*<TextArea className='dr-form-notes' tabIndex={3} />*/}
                </FormLabeledItem>
                

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/Clients/forms/DrUserForm.js